import styled from "styled-components";

export const Wrapper = styled.div`
    @media screen and (min-width: ${({ theme }) => theme.minWidth.small}) {
        width: 500px;
    }
`;
